// extracted by mini-css-extract-plugin
module.exports = {"circle":"BadgeIcon_circle_YStpz"};